export default __webpack_public_path__ + "static/media/assigned.b4ba00db.png";